/**
 * Destinazione post-login da `?next=` (Task 27): solo percorsi interni, niente open redirect.
 * Valido solo se inizia con un solo `/` (non `//` ne `/\`, che i browser trattano come host),
 * senza spazi/caratteri di controllo/backslash e senza segmenti `..`. Altrimenti null.
 */
const PATH_INTERNO = /^\/(?![/\\])[A-Za-z0-9_\-./?=&%#:@+~,;]*$/;
const DOT_SEGMENT = /(^|\/)\.\.(\/|$)/;

export const safeNext = (p: unknown): string | null => {
  if (typeof p !== 'string' || !p) return null;
  if (!PATH_INTERNO.test(p)) return null;
  if (DOT_SEGMENT.test(p.split(/[?#]/)[0])) return null;
  return p;
};
